import { useAuth0 } from "@auth0/auth0-react";
import React, { useCallback, useEffect, useMemo } from "react";
import * as Router from "react-router-dom";
import { isAuthPath, isParentPortalPath } from "src/services/url";
import * as Env from "../services/env";
import { AuthData, loading, ok, unauthenticated } from "../types/authData";
import { useOrganizationPath } from "./useOrganizationPath";

type Token = AuthData<string>;
export default function useAccessToken(): Token {
  const [accessToken, setAccessToken] = React.useState<string>();
  const wrappedToken = useMemo(
    () => (accessToken ? ok(accessToken) : loading),
    [accessToken]
  );
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const avelaOrganization = useOrganizationPath();
  const location = Router.useLocation();

  const isParent = isParentPortalPath(location.pathname);
  const getAccessToken = useCallback(async () => {
    if (!avelaOrganization || !isAuthenticated) return;
    try {
      const env = Env.read();
      const audience = env.VITE_HASURA_URL;
      const accessToken = await getAccessTokenSilently({
        audience,
        isParent,
        avelaOrganization,
      });
      setAccessToken(accessToken);
    } catch (e) {
      console.warn(e);
      throw e;
    }
  }, [avelaOrganization, getAccessTokenSilently, isAuthenticated, isParent]);

  useEffect(() => {
    if (isAuthPath(location.pathname)) {
      // We're still on /auth path, don't get token yet.
      return;
    }

    getAccessToken();
  }, [getAccessToken, location.pathname]);

  if (isLoading) return loading;
  if (!isAuthenticated) return unauthenticated;

  return wrappedToken;
}
